import { MapOverlays } from '@openlayers/ol-overlays';
import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { setMapCursor } from '@openlayers/ol-utils';
import { jsonToHtml } from '@shared/utils/utils-html';
import { PipesLayer } from '@openlayers/pipes/PipesLayer';
import Feature from 'ol/Feature';
import { DateUtils } from '@shared/utils/DateUtils';


/**
 * @author NikolaV
 */
export class PrintJsonDesktopMouseInteraction extends FeatureMouseInteraction<PipesLayer> {

    onClick = (feature: Feature, e, n): void => {
        let props = feature.get('data') ?? feature.get('properties');
        let html = '<div class="right"><i class="iki iki-cross" onclick="mapUI.hideDialog()"></i></div>' + jsonToHtml(props);
        if (props.timestampExternal) {
            html += '<div class="no-break-text">timestampExternal: ' + DateUtils.formatDateTime(props.timestampExternal) + '</div>';
        }
        MapOverlays.showDialog(this.map, html, e, n);
    };

    onMouseOver = (feature: Feature, e, n): void => {
        setMapCursor(this.map, 'pointer');
    };
}
